import { defineComponent } from "vue";
import { mapState } from "pinia";

import { useHospiceConvertToPending } from "../../../store/useHospiceConvertToPending";

import FormSection from "../../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import PatientPharmacy from "../PatientPharmacy/PatientPharmacy.vue";

export default defineComponent({
    components: {
        FormSection,
        PatientPharmacy
    },
    computed: {
        ...mapState(useHospiceConvertToPending, ["patientDetails"])
    },
    mounted() {
        if (!this.patientDetails.pharmacies?.length) {
            this.patientDetails.pharmacies = [];
        }
    },
    methods: {
        addNewPharmacy() {
            this.patientDetails.pharmacies = this.patientDetails.pharmacies.concat("");
        },
        updatePharmacyId(index: number, value: string) {
            this.patientDetails.pharmacies[index] = value;
        }
    }
});
